<button type="button"
        class="tp-trigger"
        matTooltip="Who's active"
        aria-label="Show who is active"
        [matMenuTriggerFor]="presenceMenu"
        (mouseenter)="prefetch()"
        (focus)="prefetch()"
        (menuOpened)="onOpened()"
        (menuClosed)="onClosed()">
  <mat-icon class="tp-trigger-icon" aria-hidden="true">groups</mat-icon>
</button>

<mat-menu #presenceMenu="matMenu" class="team-presence-menu" xPosition="before">
  <!-- A mat-menu closes on any click inside it; this is a panel to read, not a list of actions. -->
  <div class="tp-panel" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <div class="tp-header">
      <span class="tp-title">Team</span>
      <span class="tp-summary" *ngIf="!loading() && !failed()">{{ activeCount() }} active</span>
    </div>

    <input class="tp-filter"
           type="text"
           placeholder="Search people..."
           aria-label="Search people"
           [value]="filter()"
           (input)="onFilter($any($event.target).value)">

    <div class="tp-body">
      <div class="tp-state" *ngIf="loading()">Loading...</div>
      <div class="tp-state" *ngIf="!loading() && failed()">Couldn't load who's active. Try again shortly.</div>
      <div class="tp-state" *ngIf="!loading() && !failed() && groups().length === 0">No one found.</div>

      <ng-container *ngIf="!loading() && !failed()">
        <section *ngFor="let group of groups()" class="tp-group">
          <div class="tp-group-label">{{ group.label }} · {{ group.rows.length }}</div>
          <div *ngFor="let row of group.rows; trackBy: trackRow" class="tp-row">
            <span class="tp-avatar">
              {{ row.initials }}
              <span class="tp-dot" [ngClass]="'tp-dot-' + row.status" [attr.aria-label]="group.label"></span>
            </span>
            <span class="tp-text">
              <span class="tp-name">{{ row.name }}<span *ngIf="row.isMe" class="tp-you"> (you)</span></span>
              <span class="tp-detail">{{ row.detail }}</span>
            </span>
          </div>
        </section>
      </ng-container>
    </div>
  </div>
</mat-menu>
